import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown"
const Content = (props) => {
  const [isClient, setClient] = useState(false);
    const [active, setActive] = useState('+ Read More');
    const handleAccordionClick = () => {
      if (active === '+ Read More') {
          setActive('- Read Less')
      } else {
          setActive('+ Read More')
      }
  }
  if (props.Content && props.Content.length < 250) {
    var long_desc_first_part = props.Content;
  }
  else {
    var long_desc_first_part = props.Content ? props.Content.split(/\s+/).slice(0, 25).join(" ") : '';
  }
  useEffect(() => {
    setClient(true);
  }, [])
  return (
      <>
      {isClient && active === '+ Read More' ?
        <ReactMarkdown source={props.Content?.length > 250 ? long_desc_first_part+'...' : long_desc_first_part} allowDangerousHtml /> 
        :
        <ReactMarkdown source={props.Content} allowDangerousHtml /> 
        
  }
        {isClient && props.Content?.length > 250 && <a className="read-more custom-link" onClick={handleAccordionClick}>{active}</a>}
        </> 
)
}

export default Content;